import { Chip } from "@mui/material";
import type { JSX } from "react";

import type { SalesCampaign } from "@xop/dashboard-shared";

/** A campaign's run state and date window, as the Campaigns list and a
 * campaign's results page both show them. */

export function StatusChip({ campaign }: { campaign: SalesCampaign }): JSX.Element {
  if (campaign.is_live) {
    return <Chip label="Live" size="small" color="success" />;
  }
  if (campaign.status === "active" && !campaign.in_window) {
    // The state that silently stops a campaign — active but outside its
    // dates. Naming it prevents "I activated it, why is nothing happening?"
    return <Chip label="Active — outside its dates" size="small" color="warning" />;
  }
  if (campaign.status === "draft") {
    return <Chip label="Draft — not running" size="small" />;
  }
  return <Chip label="Archived" size="small" variant="outlined" />;
}

export function formatWindow(c: SalesCampaign): string {
  if (!c.starts_on && !c.ends_on) return "No date limit";
  if (c.starts_on && c.ends_on) return `${c.starts_on} → ${c.ends_on}`;
  if (c.starts_on) return `From ${c.starts_on}`;
  return `Until ${c.ends_on}`;
}
